import Vue from 'vue'
import VueGtag from "vue-gtag"
import App from './App.vue'
import router from './router'
import AsyncComputed from 'vue-async-computed'

Vue.use(VueGtag, {
  config: { 
    id: "G-BP1RBPWKHG"
  }
}, router);

Vue.use(AsyncComputed)
Vue.config.productionTip = false

new Vue({
  router,
  // watch:{
  //   '$route' (to, from){
  //     // console.log('to', to);
  //     // console.log('from', from);
  //      // Code
  //    }
  // },
  render: h => h(App)
}).$mount('#app')
